export const generateRegistrationurl = (keycloak) => {
  const redirectUri = encodeURIComponent(window.location.origin + "/callback");
  const nonce = Math.random().toString(36).substring(2, 15);
    const state = Math.random().toString(36).substring(2, 15);
    return `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/registrations?client_id=${keycloak.clientId}&redirect_uri=${redirectUri}&state=${state}&response_mode=fragment&response_type=code&scope=openid&nonce=${nonce}&type=PRO`;
};
